export const CALENDARIO_INICIA = 'calendario_inicia';
export const CALENDARIO_NOVO = 'calendario_novo';
export const CALENDARIO_SALVA = 'calendario_salva';
export const CALENDARIO_SALVA_SUCESSO = 'calendario_salva_sucesso';
export const CALENDARIO_BUSCA_EDICAO = 'calendario_busca_edicao';
export const CALENDARIO_BUSCA_EDICAO_SUCESSO = 'calendario_busca_edicao_sucesso';
export const CALENDARIO_LISTA_TODOS = 'calendario_lista_todos';
export const CALENDARIO_LISTA_TODOS_SUCESSO = 'calendario_lista_todos_sucesso';
export const CALENDARIO_LISTA_ESCOLAS = 'calendario_lista_escolas';
export const CALENDARIO_LISTA_ESCOLAS_SUCESSO = 'calendario_lista_escolas_sucesso';
export const CALENDARIO_CARREGA_DIAS = 'calendario_carrega_dias';
export const CALENDARIO_CARREGA_DIAS_SUCESSO = 'calendario_carrega_dias_sucesso';
export const CALENDARIO_CARREGA_TIPOS_EVENTO = 'calendario_carrega_tipos_evento';
export const CALENDARIO_CARREGA_TIPOS_EVENTO_SUCESSO = 'calendario_carrega_tipos_evento_sucesso';
export const CALENDARIO_LISTA_TURMAS = 'calendario_lista_turmas';
export const CALENDARIO_LISTA_TURMAS_SUCESSO = 'calendario_lista_turmas_sucesso';
export const CALENDARIO_SALVA_ANOTACAO = 'calendario_salva_anotacao';
export const CALENDARIO_SALVA_ANOTACAO_SUCESSO = 'calendario_salva_anotacao_sucesso';
export const CALENDARIO_REMOVE_ANOTACAO = 'calendario_remove_anotacao';
export const CALENDARIO_REMOVE_ANOTACAO_SUCESSO = 'calendario_remove_anotacao_sucesso';
export const CALENDARIO_SALVA_EVENTO_DIA = 'calendario_salva_evento_dia';
export const CALENDARIO_SALVA_EVENTO_DIA_SUCESSO = 'calendario_salva_evento_dia_sucesso';
export const CALENDARIO_REMOVE_EVENTO_DIA = 'calendario_remove_evento_dia';
export const CALENDARIO_REMOVE_EVENTO_DIA_SUCESSO = 'calendario_remove_evento_dia_sucesso';
export const CALENDARIO_LIMPAR = 'calendario_limpar';
export const CALENDARIO_ERRO = 'calendario_erro';
export const CALENDARIO_SELECIONA_DIA = 'calendario_seleciona_dia';
